<div class="nav-panel"><ng-template appNavigHost=""></ng-template></div>